export default "__VITE_ASSET__CYdkMqK5__"